var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-form-item',{staticClass:"form-item",attrs:{"prop":_vm.prop,"show-message":false}},[_vm._t("default",[_c('el-input',{attrs:{"disabled":_vm.disabled,"data-qa":_vm.dataQa},model:{value:(_vm.model[_vm.prop]),callback:function ($$v) {_vm.$set(_vm.model, _vm.prop, $$v)},expression:"model[prop]"}})])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18da87b3","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/common/components/rest/RestListColumnEditable.vue
// module id = null
// module chunks = 